//
import Service from '@/services/service'
import ProviderPaymentModel from '@/models/Purchase/PchProviderPayment'

/**
 * This class describes a pch provider payment.
 *
 * @class PchProviderPayment (name)
 */
export default class PchProviderPayment extends Service {

  /**
   * { function_description }
   *
   * @return {<type>} { description_of_the_return_value }
   */
  resource() {
    return ProviderPaymentModel
  }

  /**
   * Returns a list representation of the object.
   *
   * @return     {<type>}  List representation of the object.
   */
  toList() {
  	return this
  		.include(
				'pch_detail_provider_payment_sheet',
				'pch_provider_account_movement',
				'g_user.hr_employee',
				'pch_provider',
				'pch_detail_provider_payments.pch_provider_debt_to_pay.pch_purchase_invoice',
				'pch_detail_provider_payments.pch_provider_debt_to_pay.pch_purchase_debit_note',
				'pch_provider_payment_pos_payment_types.pos_sale_payment_type',
  		)
  }
}
